import { addDays } from '../offers/offerUtils';
import { MAX_WINDOW_DAYS, type PackageFieldErrors } from './packageUtils';
import type { PackagesT } from './packagesI18n';

export interface PackageWindowFieldsProps {
  t: PackagesT;
  startsAt: string;
  endsAt: string;
  /** Dubai today (yyyy-MM-dd). */
  today: string;
  /** A running package keeps its past start date; the input then has no `min`. */
  startLocked: boolean;
  disabled?: boolean;
  fieldErrors: PackageFieldErrors;
  onChange: (key: 'startsAt' | 'endsAt', value: string) => void;
}

/** Spec 081b — optional start/end (Asia/Dubai days, D9): start today or later, end ≥ start, ≤ 90 days. */
export default function PackageWindowFields(props: PackageWindowFieldsProps) {
  const { t, startsAt, endsAt, today, startLocked, disabled, fieldErrors, onChange } = props;
  const errProps = (f: 'startsAt' | 'endsAt') => (fieldErrors[f]
    ? { 'aria-invalid': true as const, 'aria-describedby': `pkg-err-${f}` }
    : {});
  const err = (f: 'startsAt' | 'endsAt') => (fieldErrors[f]
    ? <div className="offer-field-error" id={`pkg-err-${f}`} role="alert">{fieldErrors[f]}</div>
    : null);

  return (
    <>
      <div className="offer-grid-2">
        <div className="offer-field">
          <label htmlFor="pkg-startsAt">{t('packages.field.startsAt')} <span className="offer-optional">({t('packages.field.optional')})</span></label>
          <input id="pkg-startsAt" type="date" min={startLocked ? undefined : today} value={startsAt} disabled={disabled}
            onChange={(e) => onChange('startsAt', e.target.value)} {...errProps('startsAt')} />
          {err('startsAt')}
        </div>
        <div className="offer-field">
          <label htmlFor="pkg-endsAt">{t('packages.field.endsAt')} <span className="offer-optional">({t('packages.field.optional')})</span></label>
          <input id="pkg-endsAt" type="date" min={startsAt || today} max={startsAt ? addDays(startsAt, MAX_WINDOW_DAYS) : undefined}
            value={endsAt} disabled={disabled} onChange={(e) => onChange('endsAt', e.target.value)} {...errProps('endsAt')} />
          {err('endsAt')}
        </div>
      </div>
      <p className="offer-field-hint">{t('packages.hint.window')}</p>
    </>
  );
}
